// extracted by mini-css-extract-plugin
export default {"wrap":"AppRoutes_wrap__P7Vc9"};